module.exports = __webpack_public_path__ + "img/logoAEMP_v2b.8432aa78.png";